import { useSelector } from 'react-redux';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { HR } from 'foundations-components/transitional/components/HR';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { getLineItemRecurringFrequencyBySubtotal } from '../../utils/recurring';
import { useSubtotals } from '../../context/SubtotalsProvider';
import FormattedPrice from '../Utilities/FormattedPrice';
import { FUTURE_START_DATE, RELATIVE_START_DATE } from '../../constants/LineItems';
import { getBuyerOverridesIsLoading } from '../../state/BuyerOverrides/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hasRelativeDelay = initialPayment => initialPayment.type === RELATIVE_START_DATE && !!initialPayment.relativeDelay;

/**
 * Text that shows up below the Pay button when there are future start date line items.
 */
const MaybeFutureChargesTotals = () => {
  const {
    loading,
    recurringSubtotals,
    currencyCode
  } = useSubtotals();
  const hasMultipleSubscriptions = recurringSubtotals.length > 1;
  const loadingBuyerOverrides = useSelector(getBuyerOverridesIsLoading);
  if (loading || loadingBuyerOverrides) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "maybe-future-charges-total-loading"
    });
  }
  if (!recurringSubtotals.length) {
    return null;
  }
  if (hasMultipleSubscriptions) {
    return null;
  }
  const {
    recurringBillingTerms: {
      initialPayment: {
        type,
        futureStartDate
      },
      initialPayment,
      intervalLength,
      intervalUnit
    },
    subtotal
  } = recurringSubtotals[0];
  if (type !== FUTURE_START_DATE && type !== RELATIVE_START_DATE) {
    return null;
  }
  const recurringBillingFrequency = getLineItemRecurringFrequencyBySubtotal(intervalUnit, intervalLength);
  const recurringBillingTerm = /*#__PURE__*/_jsx(FormattedPrice, {
    currencyCode: currencyCode,
    price: subtotal,
    frequency: recurringBillingFrequency,
    simplify: false,
    currencyAndAmountProps: {
      typography: 'body-125'
    }
  });
  const delayUnit = hasRelativeDelay(initialPayment) && initialPayment.relativeDelay.delayUnit;
  const delayLength = hasRelativeDelay(initialPayment) && initialPayment.relativeDelay.delayLength;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsxs(Text, {
      textAlign: "center",
      as: "small",
      "data-test-id": "maybe-future-charges-totals",
      children: [type === FUTURE_START_DATE && /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "payments.futureChargesTotals.futureChargesTotalsAndDate",
        options: {
          recurringBillingTerm,
          date: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: Number(futureStartDate),
            format: "LL",
            type: "utc"
          })
        }
      }), type === RELATIVE_START_DATE && /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `payments.futureChargesTotals.futureChargesTotalsAndRelativeDate.${delayUnit}_jsx`,
        options: {
          recurringBillingTerm,
          delayLength,
          count: delayLength
        }
      })]
    }), /*#__PURE__*/_jsx(HR, {})]
  });
};
export default MaybeFutureChargesTotals;